import { useQuery } from '@tanstack/react-query';

import { laneOptions } from '../data-provider/lane';
import type { LaneItem } from '../models';

export const useGetLane = (laneKey: LaneItem['laneKey']) => useQuery(laneOptions(laneKey));
